import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import Axios from 'axios'

Axios.defaults.baseURL = 'https://demo-backend.testdrive-heroes.com/'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Vuelidate,
  Axios,
  render: h => h(App)
}).$mount('#app')
